__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "network-scanning";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@db_ui/singletons-ui-lib", "1.0.15", () => (Promise.all([__webpack_require__.e(1572), __webpack_require__.e(8874), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(11572))))));
			register("@db_ui/smartback", "1.0.8", () => (Promise.all([__webpack_require__.e(7826), __webpack_require__.e(3426), __webpack_require__.e(3001)]).then(() => (() => (__webpack_require__(35382))))));
			register("@microsoft/applicationinsights-react-js", "3.4.3", () => (Promise.all([__webpack_require__.e(1630), __webpack_require__.e(3426), __webpack_require__.e(4190)]).then(() => (() => (__webpack_require__(51809))))));
			register("@microsoft/applicationinsights-web", "2.8.16", () => (Promise.all([__webpack_require__.e(1630), __webpack_require__.e(6272)]).then(() => (() => (__webpack_require__(6272))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(9733), __webpack_require__.e(3504), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "6.8.0", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.2.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(1912), __webpack_require__.e(3426)]).then(() => (() => (__webpack_require__(41912))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};